<template>
  <div>
    <modal-padrao
      ref="modal-registro-informativo"
      max-width="90%"
      :titulo="$t('modulos.orcamentos.registro_informativos')"
      :mostrar-botoes="false"
    >
      <v-form ref="form" class="row mt-2" v-if="form">
        <input-text
          v-model="form.ultimoRegistro"
          class="col-12 col-md-4"
          :label="$t('modulos.registro_informativo.formulario.codigo')"
          disabled
          :max="100"
        />
        <input-date
          v-model="form.dataEmissao"
          class="col-12 col-md-4"
          :label="$t('modulos.registro_informativo.formulario.data_emissao')"
          obrigatorio
          disabled
        />
        <input-date
          v-model="form.dataOcorrencia"
          class="col-12 col-md-4"
          :label="$t('modulos.registro_informativo.formulario.data_ocorrencia')"
          obrigatorio
          disabled
        />
        <input-text
          v-model="ocorrenciaPadrao"
          class="col-12 col-md-3"
          :label="
            $t('modulos.registro_informativo.formulario.ocorrencia_padrao')
          "
          :multiplos="false"
          obrigatorio
          disabled
        />
        <input-text
          v-model="form.nome"
          obrigatorio
          class="col-12 col-md-9"
          :label="$t('modulos.registro_informativo.formulario.nome')"
          disabled
        />
        <input-textarea
          v-model="form.ocorrencia"
          obrigatorio
          class="col-12"
          :label="$t('modulos.registro_informativo.formulario.ocorrencia')"
          disabled
        />
        <input-textarea
          v-model="form.acaoCorretiva"
          obrigatorio
          class="col-12"
          :label="$t('modulos.registro_informativo.formulario.acao_corretiva')"
          disabled
        />
        <input-ordem-servico
          v-model="form.ordemServico.nome"
          obrigatorio
          class="col-12 col-md-4 text-center"
          :label="$t('modulos.registro_informativo.formulario.ordem_servico')"
          :multiplos="false"
          disabled
        />
        <input-text
          v-model="form.participante.nome"
          obrigatorio
          disabled
          class="col-12 col-md-8"
          :label="$t('modulos.registro_informativo.formulario.participante')"
        />
        <input-textarea
          v-model="form.texto"
          class="col-12"
          :label="$t('modulos.registro_informativo.formulario.texto')"
          disabled
        />
        <input-usuarios
          v-model="form.usuarioResponsavel.nome"
          obrigatorio
          class="col-12"
          :label="
            $t('modulos.registro_informativo.formulario.usuario_responsavel')
          "
          :multiplos="false"
          disabled
        />
      </v-form>
    </modal-padrao>
  </div>
</template>
<script>
import OcorrenciaPadraoService from '@common/services/cadastros/OcorrenciaPadraoService';
import { OcorrenciaPadraoModel } from '@common/models/cadastros/OcorrenciaPadraoModel';
import { InputUsuarios, InputOrdemServico } from '@components/inputs';
export default {
  components: {
    InputUsuarios,
    InputOrdemServico,
  },
  props: {
    form: { type: Object, default: () => {} },
  },
  data() {
    return {
      dadosOcorrencia: new OcorrenciaPadraoModel({}),
      ocorrenciaPadrao: '',
    };
  },
  mounted() {},
  methods: {
    abrirModal() {
      this.$refs['modal-registro-informativo'].abrirModal();
      this.buscaDadosOcorrenciaPadrao();
    },
    fecharModal() {
      this.$refs['modal-registro-informativo'].fecharModal();
    },
    buscaDadosOcorrenciaPadrao() {
      this.$store.dispatch('Layout/iniciarCarregamento');
      OcorrenciaPadraoService.buscar(this.form?.ocorrenciaPadraoId)
        .then((res) => {
          this.ocorrenciaPadrao = res.data?.nome;
        })
        .catch(() => {
          this.toastErro(
            this.$t('modulos.ocorrencia_padrao.erros.id_invalido')
          );
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
  },
};
</script>
